export class Utils {
	constructor() {
		Utils.getScrollbarWidth();
		window.addEventListener('resize', (): void => Utils.getScrollbarWidth());
	}

	private static getScrollbarWidth(): void {
		const outer: HTMLDivElement = document.createElement('div');
		outer.style.visibility = 'hidden';
		outer.style.overflow = 'scroll';
		document.body.appendChild(outer);

		const inner: HTMLDivElement = document.createElement('div');
		outer.appendChild(inner);

		const scrollbarWidth: number = outer.offsetWidth - inner.offsetWidth;

		outer.parentNode.removeChild(outer);

		document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
		document.documentElement.style.setProperty(
			'--scrollbar-half-width',
			`${Math.round(scrollbarWidth / 2)}px`
		);
	}
}
